import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import Home from './pages/Home';
import Live from './pages/Live';
import Courses from './pages/Courses';
import Basics from './pages/Basics';
import AdminLayout from './pages/admin/AdminLayout';

function App() {
  return (
    <StoreProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/basics" element={<Basics />} />
          <Route path="/live" element={<Live />} />
          <Route path="/admin/*" element={<AdminLayout />} />
        </Routes>
      </Router>
    </StoreProvider>
  );
}

export default App;